module.exports = ":host .field-info-half-with {\n  width: 50%; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/integrations/shootProof/modals/create-new-shootProof-gallery-modal/create-new-shootProof-gallery.modal.scss
// module id = ./web/modern/components/integrations/shootProof/modals/create-new-shootProof-gallery-modal/create-new-shootProof-gallery.modal.scss
// module chunks = 0